<div class="copy__panel">
    <div class="panel-left">
        <button
            type="button"
            mat-flat-button
            class="add-btn"
            (click)="onAddLeftTree()"
        >
            <mat-icon>add</mat-icon>
            Dodaj publikację
        </button>
    </div>
    <div class="panel-right">
        <button
            type="button"
            mat-flat-button
            class="remove-btn"
            (click)="onRemoveRightNode()"
        >
            <mat-icon>remove</mat-icon>
            Usuń element
        </button>
        <button
            type="button"
            mat-flat-button
            class="add-btn"
            (click)="onAddRightTree()"
        >
            <mat-icon>add</mat-icon>
            Dodaj publikację
        </button>
    </div>
</div>
<div class="copy__body">
    <gwo-copy-tree
        #leftTree
        [publication]="donorPublication$ | async"
        title="Do wyboru"
    />
    <div class="btn-group">
        <button
            type="button"
            mat-flat-button
            class="add-btn"
            (click)="onNodeCopy()"
        >
            <mat-icon>input</mat-icon>
            Kopiuj
        </button>
    </div>
    <gwo-copy-tree
        #rightTree
        [publication]="publication$ | async"
        title="Zatwierdzone"
        side="right"
    />
</div>
<div class="copy__panel">
    <div class="panel-right">
        <button
            type="button"
            mat-flat-button
            class="add-btn"
            (click)="onSave()"
            [disabled]="isSaving$ | async"
        >
            <mat-icon
                >{{ (isSaving$ | async) ? "hourglass_empty" : "save" }}
            </mat-icon>
            {{ (isSaving$ | async) ? "Zapisywanie..." : "Zapisz do bazy" }}
        </button>
    </div>
</div>
@if (saveError$ | async; as error) {
    <p class="error">
        {{ error }}
    </p>
}
